import React from "react";
import ContextProvider from "./context/ContextProvider";
import { AppearanceProvider } from "react-native-appearance";
import Loader from "./Loader";
import { DripsyProvider } from "dripsy";
import { theme } from "./context/Theme";
import Localize from "./Localize";
import { NavigationContainer } from "@react-navigation/native";

function App() {
  return (
    <NavigationContainer>
      <ContextProvider>
        <AppearanceProvider>
          <DripsyProvider theme={theme}>
            <Loader />
            <Localize />
          </DripsyProvider>
        </AppearanceProvider>
      </ContextProvider>
    </NavigationContainer>
  );
}

export default App;
